"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Heading from "./webflow_modules/Basic/components/Heading";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Icon from "./webflow_modules/Icon/components/Icon";
import Link from "./webflow_modules/Basic/components/Link";
import SliderArrow from "./webflow_modules/Slider/components/SliderArrow";
import SliderMask from "./webflow_modules/Slider/components/SliderMask";
import SliderNav from "./webflow_modules/Slider/components/SliderNav";
import SliderSlide from "./webflow_modules/Slider/components/SliderSlide";
import SliderWrapper from "./webflow_modules/Slider/components/SliderWrapper";
import * as _interactions from "./webflow_modules/interactions";
import { HeroSliderSlide } from "./HeroSliderSlide";
import { SearchInputHomePage } from "./SearchInputHomePage";

const _interactionsData = JSON.parse(
  '{"events":{"e-123":{"id":"e-123","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-41","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-124"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a69085","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a69085","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1707853020650},"e-125":{"id":"e-125","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-41","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-126"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a6908f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a6908f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1707853020650}},"actionLists":{"a-41":{"id":"a-41","title":"Hero Modal [open]","actionItemGroups":[{"actionItems":[{"id":"a-41-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":"none"}},{"id":"a-41-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-41-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":"flex"}},{"id":"a-41-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1707139287082}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function HomeHero({
  searchInputSlot = "",
  toggleSearchButtonProps = {},
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <Block className={"home-hero"} tag={"header"}>
      <Block className={"hero-form"} tag={"div"}>
        <Block className={"padding-global"} tag={"div"}>
          <Block className={"hero-form_wrapper"} tag={"div"}>
            <Block className={"div-block-91"} tag={"div"}>
              <Block className={"margin-bottom margin-small"} tag={"div"}>
                <Heading className={"hero-h1"} tag={"h1"}>
                  {"Uncover Your Oasis"}
                </Heading>
              </Block>
              <Block className={"margin-bottom margin-medium"} tag={"div"}>
                <Block className={"div-block-81"} tag={"div"}>
                  <Block
                    className={
                      "hero_modal-trigger-wrapper position-absolute z-index-2"
                    }
                    tag={"div"}
                    {...toggleSearchButtonProps}
                  />
                  <Link
                    block={"inline"}
                    button={false}
                    className={"accessibility-link position-absolute z-index-1"}
                    id={"main-content"}
                    options={{
                      href: "#",
                    }}
                  >
                    <Block
                      className={"hero-form_form-wrapper-copy"}
                      tag={"div"}
                    >
                      <Block className={"fake-input"} tag={"div"}>
                        <Block className={"fake-input-field"} tag={"div"}>
                          {"Search by location or community ..."}
                        </Block>
                      </Block>
                      <Block className={"fake-submit-button"} tag={"div"}>
                        <Block className={"text-block-13"} tag={"div"}>
                          {"Search"}
                        </Block>
                      </Block>
                    </Block>
                  </Link>
                  <Block
                    className={"hero_modal-trigger"}
                    tag={"div"}
                    {...toggleSearchButtonProps}
                  />
                </Block>
              </Block>
            </Block>
            <Block className={"text-size-large spacing-medium"} tag={"div"}>
              {"Experience Hassle-Free Living"}
            </Block>
          </Block>
        </Block>
      </Block>
      <SliderWrapper
        animation={"slide"}
        autoMax={0}
        autoplay={true}
        className={"hero-slider"}
        delay={4000}
        disableSwipe={false}
        duration={500}
        easing={"ease-in-out"}
        hideArrows={false}
        iconArrows={true}
        infinite={true}
        navInvert={false}
        navNumbers={false}
        navRound={true}
        navShadow={false}
        navSpacing={3}
      >
        <SliderMask>
          <SliderSlide className={"hero-slider_slide"} tag={"div"}>
            <HeroSliderSlide
              bottomTextText={"Oakland, CA"}
              heroSliderSlideImageImage={
                "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/6a8789905de686a78b565b46_domain-weho.avif"
              }
              imagePriority={"high"}
              topTextText={"Axis"}
            />
          </SliderSlide>
          <SliderSlide className={"hero-slider_slide"} tag={"div"}>
            <HeroSliderSlide
              bottomTextText={"Seattle WA"}
              heroSliderSlideImageImage={
                "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65cd3325515a317880ba082a_Eastlake-Fire%20Pit%20High.jpeg"
              }
              imagePriority={"auto"}
              topTextText={"Eastlake"}
            />
          </SliderSlide>
          <SliderSlide className={"hero-slider_slide"} tag={"div"}>
            <HeroSliderSlide
              bottomTextText={"West Sacramento, CA"}
              heroSliderSlideImageImage={
                "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/69654a0afbd5ee415ea63c7b_Hero%20Slider%20-%20Capitol%20Yards.jpeg"
              }
              imagePriority={"auto"}
              topTextText={"Capitol Yards"}
            />
          </SliderSlide>
          <SliderSlide className={"hero-slider_slide"} tag={"div"}>
            <HeroSliderSlide
              bottomTextText={"Los Angeles CA"}
              heroSliderSlideImageImage={
                "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65cd33254a49cdcd15276da3_Bahay-Kitchen%20High.jpeg"
              }
              imagePriority={"auto"}
              topTextText={"Bahay"}
            />
          </SliderSlide>
        </SliderMask>
        <SliderArrow className={"left-arrow-2"} dir={"left"}>
          <Icon
            className={"icon-4"}
            widget={{
              type: "icon",
              icon: "slider-left",
            }}
          />
        </SliderArrow>
        <SliderArrow className={"right-arrow-2"} dir={"right"}>
          <Icon
            className={"icon-3"}
            widget={{
              type: "icon",
              icon: "slider-right",
            }}
          />
        </SliderArrow>
        <SliderNav className={"slide-nav"} />
      </SliderWrapper>
      <Block
        className={"search_modal___opacity-_0-hide-me"}
        // @ts-ignore - User-defined custom attribute(s)
        role={"dialog"}
        tag={"div"}
      >
        <Block
          className={"search_modal-close-button"}
          tag={"div"}
          {...toggleSearchButtonProps}
        >
          <HtmlEmbed
            className={"html-embed-4"}
            content={
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>'
            }
          />
        </Block>
        <Block
          aria-hidden={"true"}
          className={"search_modal-close-trigger"}
          // @ts-ignore - User-defined custom attribute(s)
          tabIndex={-1}
          tag={"div"}
          {...toggleSearchButtonProps}
        />
        <Block className={"search-modal-slot-container"} tag={"div"}>
          {searchInputSlot ?? (
            <Block className={"search-modal-input-container"} tag={"div"}>
              <SearchInputHomePage showClear={true} showPopover={true} />
            </Block>
          )}
        </Block>
        <Link
          block={"inline"}
          button={false}
          className={"search-modal-close-button"}
          options={{
            href: "#",
          }}
          {...toggleSearchButtonProps}
        >
          <Block className={"div-block-106"} tag={"div"}>
            <HtmlEmbed
              className={"search-modal-close-icon"}
              content={
                '<!--<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>\n-->\n<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">\n  <path fill="currentColor" d="M345 137l17-17L328 86.1l-17 17-119 119L73 103l-17-17L22.1 120l17 17 119 119L39 375l-17 17L56 425.9l17-17 119-119L311 409l17 17L361.9 392l-17-17-119-119L345 137z"/></svg>'
              }
            />
            <Block className={"text-block-15"} tag={"div"}>
              {"Close"}
            </Block>
          </Block>
        </Link>
      </Block>
    </Block>
  );
}
